<div class='modal' id='edit-preferences-modal' [class.is-active]="visible">
  <div class='modal-background'></div>
  <div class='modal-card'>
    <header class='modal-card-head'>
      <p i18n="@@changePassword" class='modal-card-title'>Cambio password</p>
      <button class='delete' (click)="close()"></button>
    </header>
    <section class='modal-card-body'>
      <label i18n="@@oldPassword" class="label">Password attuale</label>
      <p class="control">
        <input type="password" class="input" name="oldPassword" [(ngModel)]="oldPassword" />
      </p>
      <label class="label">Password</label>
      <p class="control">
        <input type="password" class="input" name="password" [(ngModel)]="password" />
      </p>
      <label i18n="@@confirmPassword" class="label">Conferma password</label>
      <p class="control">
        <input type="password" class="input" name="confirmPassword" [(ngModel)]="confirmPassword" />
      </p>
      <div class="notification is-danger" *ngIf="errors?.length" style="margin-top: 1.5em">
        <p *ngFor="let error of errors">{{error.description}}</p>
      </div>
    </section>
    <footer class='modal-card-foot'>
      <a class='button is-primary modal-save' i18n="@@confirm" (click)="changePassword()">Conferma</a>
      <a class='button modal-cancel' i18n="@@cancel" (click)="close()">Annulla</a>
    </footer>
  </div>
</div>
